// extracted by mini-css-extract-plugin
export default {"notifications":"AddNotificationModalContent-notifications-wmzKT"};